import angular from 'angular';
import _ from 'lodash';


export default class BaseStore {
    constructor ($q, R) {
        "ngInject";
        this.$q = $q;
        this.R = R;
        this.loading = false;
        this.list = [];
        this.count = 0;
        this.endpoint = R.all('dummy');
        this.params = {};
        this.isEmpty = false;
        this.defer = $q.defer();
        this.$promise = this.defer.promise;
    }

    resetParams () {
        this.params = {};
    }

    init () {
        this.resetParams();
        this.list = [];
        this.isEmpty = false;
    }

    get (id, params) {
        params = params || {};
        id = _.toString(id);
        return this.endpoint.get(id, params);
    }

    create (data) {
        return this.endpoint.post(data);
    }

    remove (id) {
        let self = this;
        let index = self.list.findIndex(field => field.id === id);
        if (index > -1) {
            let field = self.list[index];
            return field.remove(this.params, {'Content-Type': 'application/json'}).then(function(resp){
                self.list.splice(index, 1);
                return resp;
            });
        }
        return self.$q.resolve();
    }

    restangularize (obj) {
        return this.R.restangularizeElement(null, obj, this.endpoint.route);
    }

    refresh () {
        let self = this;
        return self._refresh().then(function(data){
            self.list = data;
            return self;
        });
    }

    loadMore () {
        let self = this;
        self.params.page = (self.params.page || 0) + 1;
        return self._refresh().then(function(data){
            self.list.push(...data);
            return self;
        });
    }

    _refresh () {
        var self = this;
        self.loading = true;
        return self.endpoint.getList(self.params)
            .then(function(data){
                self.count = data.count;
                self.isEmpty = !data.next;
                self.defer.resolve(data);
                return data;
            }, function (data) {
                self.defer.reject(data);
            })
            .finally(function(){
                self.loading = false;
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/stores/base.js